const TIPO_AUTORIZACION_OPTIONS = [
    { value: 1, text: 'Permiso c/Goce', color: 'green' },
    { value: 2, text: 'Permiso s/Goce', color: 'orange' },
    { value: 3, text: 'Horas Extras', color: 'blue' },
    { value: 4, text: 'Descanso Trabajado', color: 'purple' },
    { value: 5, text: 'Festivo Trabajado', color: 'red' },
    { value: 6, text: 'Permiso c/Goce Entrada', color: 'cyan' },
    { value: 7, text: 'Permiso s/Goce Entrada', color: 'cyan' },
    { value: 8, text: 'Permiso c/Goce Salida', color: 'cyan' },
    { value: 9, text: 'Permiso s/Goce Salida', color: 'cyan' }
];

export const getTipoAutorizacionText = (value) => {
    const tipo = TIPO_AUTORIZACION_OPTIONS.find(t => t.value === value);
    return tipo ? tipo.text : 'N/A';
};

export const getTipoAutorizacionColor = (value) => {
    const tipo = TIPO_AUTORIZACION_OPTIONS.find(t => t.value === value);
    return tipo ? tipo.color : 'default';
};

export default TIPO_AUTORIZACION_OPTIONS;
